// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"6b6c32a6","135":"9afba245","411":"4b5d2d68","601":"ff23e4db","910":"20313e0a","982":"fb0b256a"}[chunkId] + ".chunk.css";
};